// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_nw-0";